{
  "dss": {
    "button": {
      "back": "Tagasi",
      "cancel": "Tühista",
      "close": "Sulge",
      "confirmDelete": "Jah, kustuta",
      "continue": "Jätka",
      "logout": "Logi välja",
      "passwordReset": "Parooli lähtestamine",
      "save": "Salvesta",
      "verify": "Kinnita"
    },
    "error": {
      "403": "Teil puudub juurdepääs sellele lehele.",
      "404": "Seda lehte ei ole olemas.",
      "generic": "Tekkis viga. Palun proovige hiljem uuesti.",
      "throttling": "Liiga palju katseid. See toiming on mõneks ajaks blokeeritud.",
      "title": "Viga",
      "title403": "Juurdepääs keelatud",
      "title404": "Ei leitud"
    },
    "footer": {
      "imprint": "Impressum",
      "legalEntity": "ANDREAS STIHL AG & Co. KG, D-71336 Waiblingen",
      "privacy": "Privaatsuspoliitika",
      "terms": "Tingimused"
    },
    "label": {
      "CRMAccountNumber": "CRM-konto number",
      "contact": "Kontakt",
      "email": "E-post",
      "faq": "KKK",
      "female": "Pr.",
      "firstname": "Eesnimi",
      "help": "Abi",
      "language": "Keel",
      "lastname": "Perekonnanimi",
      "male": "Hr.",
      "needHelp": "Vajate abi?",
      "newPassword": "Uus parool",
      "newPassword2": "Kinnita uus parool",
      "oldPassword": "Praegune parool",
      "organization": "Organisatsioon",
      "password": "Parool",
      "required": "kohustuslik",
      "salutation": "Pöördumine",
      "select": "Palun valige"
    },
    "lang": {
      "de": "Saksa"
    },
    "link": {
      "contact": "https://support.stihl.com/en-INT/websso-ext-contact/",
      "faq": "https://support.stihl.com/en-INT/externalkbsearchwebsso/"
    },
    "page": {
      "confirm": {
        "title": "Kinnita registreerimine",
        "wait": "Palun oodake, kuni konto kinnitamine on lõpule viidud."
      },
      "otp": {
        "btnResend": "Saada kinnituskood uuesti",
        "msg": {
          "invalidOTP": "Sisestatud ühekordne parool on vigane.",
          "resendFail": "Koodi uuesti saatmine ebaõnnestus. Palun proovige hiljem uuesti."
        },
        "spamDetail": "Kontrollige oma postkasti ja rämpsposti kausta STIHL toe (noreply{'@'}stihl-sso.com) kirja",
        "spamTitle": "Ei saanud e-kirja?",
        "subtitle": "Jätkamiseks peate kinnitama oma e-posti aadressi.",
        "title": "Kinnitage oma kasutajakonto",
        "txtVerifyMail": "Palun sisestage uus kinnituskood, mille saatsime teie e-posti aadressile {email}"
      },
      "personal": {
        "msg": {
          "noChange": "Midagi pole uuendada.",
          "updateError": "Isikuandmete värskendamine ebaõnnestus.",
          "updated": "Isikuandmed on uuendatud.",
          "userLoadErr": "Kasutajaandmete laadimisel tekkis viga. Palun proovige hiljem uuesti."
        },
        "secOrganization": "Organisatsioon",
        "secPersonal": "Isiklik",
        "secSettings": "Eelistatud seaded",
        "title": "Isikuandmed"
      },
      "postPwSet": {
        "info": "Nüüd saate kasutada oma uut parooli.",
        "link_name": "Jätka iseteenindusse",
        "link_url": "/user/ui/",
        "title": "Teie parool on muudetud"
      },
      "resetPW": {
        "title": "Lähtestage oma parool"
      },
      "security": {
        "2fa": {
          "availableMethods": "Saadaolevad 2FA meetodid:",
          "info": "Kahefaktoriline autentimine (2FA) on turvafunktsioon, mis lisab teie kontole täiendava kaitsekihi. See nõuab sisselogimisel kahe meetodi kasutamist, mitte ainult kasutajanime ja parooli.",
          "method": {
            "email": "E-post",
            "emailDesc": "Saate ühekordsed koodid e-posti teel, et lõpetada autentimistaotlused.",
            "oath": {
              "add": {
                "button": "Registreeri autentimisrakendus"
              }
            }
          }
        },
        "authenticator": "Autentimisrakendus",
        "infoFederatedAccount": "Seda kontot haldab teie organisatsiooni identiteediteenuse pakkuja, mistõttu parooli ei saa siin muuta. Parooli muutmiseks logige sisse oma organisatsiooni sisselogimislehe kaudu või võtke ühendust oma IT-administraatoriga.",
        "lastUse": "Viimati kasutatud {0}.",
        "msg": {
          "invalidPassword": "Sisestatud praegune parool on vigane.",
          "passwordAlreadyUsed": "Viimaseid 5 parooli ei saa uuesti kasutada.",
          "pwUpdateError": "Parooli muutmisel tekkis viga.",
          "pwUpdated": "Parool on muudetud."
        },
        "noDevice": "Pole konfigureeritud",
        "oathAdd": {
          "appInfo": "STIHL-i sisselogimise lihtsustamiseks saate kasutada autentimisrakendusi nagu {0}, {1}, {2} jne, et luua ühekordseid paroole, mida kasutatakse sisselogimisprotsessi teise faktorina.<br/>Kui olete oma mobiilseadme kaotanud või unustanud, saate alati kasutada e-posti teel saadetud 2FA-koodi.<br/><br/>Palun järgige allolevaid juhiseid, et seadistada oma autentimisseade.",
          "badCode": "Vigane kood, palun proovige uuesti.",
          "error": "Autentimisseadme registreerimisel tekkis viga.",
          "headScan": "1. Skannige QR-kood oma autentimisrakendusega",
          "headVerify": "2. Kinnitage kood",
          "infoKey": "seadistusvõti",
          "infoKeyTitle": "Teie kahefaktorilise autentimise saladus",
          "infoScanBottom": "Ei saa skannida? Saate kasutada {0}, et oma autentimisrakendus käsitsi seadistada.",
          "infoVerify": "Sisestage kood, mille teie autentimisrakendus genereerib.",
          "success": "Teie autentimisseade on registreeritud. Nüüd saate seda sisselogimiseks kasutada.",
          "title": "Registreerige oma kahefaktorilise autentimise seade"
        },
        "oathDelete": {
          "error": "Autentimisseadme kustutamisel tekkis viga.",
          "success": "Autentimisseade on kustutatud."
        },
        "passkeys": {
          "about": {
            "info1": "Passkey'd on krüptovõtmete paarid (avalik võti ja privaatvõti), mida talletab teie kontrollitav autentija. Autentija saab tõendada, et kasutaja on kohal ja tal on luba passkey'd kasutada. Autentijad tõendavad õigust PIN-koodi, parooli, biomeetria või seadmeparooliga, sõltuvalt autentija võimalustest ja seadistusest. Autentijaid on mitut tüüpi, näiteks iPhone või Android-seade, Windows Hello, FIDO2 riistvaraline turvavõti või paroolihaldur.",
            "info2": "Kui logite STIHL-i sisse passkey'ga, kasutab teie autentija avaliku võtme krüptograafiat, et tõendada teie identiteeti STIHL-i ees ilma passkey'd kunagi saatmata. Passkey'd on seotud veebidomeeniga, nagu stihl-sso.com, ja nõuavad turvalist ühendust, mis tähendab, et veebibrauser keeldub autentimast sarnasel pettuselehel. Need omadused muudavad passkey'd väga püüdmiskindlaks ja tunduvalt raskemini rünnatavaks kui SMS või TOTP 2FA, mida saab õngitseda.",
            "info3": "Pilvega sünkroonitavad passkey-teenused võimaldavad passkey'sid seadmete vahel sünkroonida (nt Apple'i seadmed, Android-seadmed või paroolihaldurid), et neid saaks kasutada rohkemates kohtades ja need läheksid vähem kaduma. Kui olete seadnud sünkroonitud passkey ühel seadmel, on see kättesaadav mitmel seadmel, mis kasutavad sama teenust. Näiteks kui registreerite passkey oma iCloudi kontoga, kasutades MacBooki Touch ID-d, saate seda passkey'd kasutada seejärel näo, sõrmejälje, PIN-koodi või seadmeparooliga mitmel seadmel, mis on seotud sama iCloudi kontoga.",
            "title": "Passkey'dest"
          },
          "add": {
            "button": "Lisa uus passkey",
            "error": "Uue passkey lisamisel tekkis viga.",
            "success": "Uus passkey on lisatud."
          },
          "delete": {
            "button": "Kustuta passkey",
            "error": "Selle passkey kustutamisel tekkis viga.",
            "success": "Passkey on kustutatud."
          },
          "edit": {
            "error": "Passkey nime salvestamisel tekkis viga",
            "name": "Passkey nimi",
            "success": "Passkey nimi on uuendatud.",
            "title": "Pange oma passkey'le nimi, et eristada seda teistest"
          },
          "info": "Passkey on lihtne ja turvaline alternatiiv paroolidele, mis kinnitab teie isikut puudutuse, näotuvastuse, seadmeparooli või PIN-koodi abil.",
          "none": "Ühtegi passkey'd pole konfigureeritud.",
          "reallyDelete": "Kas olete kindel, et soovite passkey kustutada?",
          "registeredPasskeys": "Teie registreeritud passkey'd:",
          "title": "Passkey'd"
        },
        "reallyDeleteDevice": "Kas olete kindel, et soovite autentimisseadme kustutada?",
        "secMFA": "Kahefaktoriline autentimine",
        "secPwdChange": "Muuda parooli",
        "title": "Turvalisus"
      },
      "setPW": {
        "acceptTC": "Palun kinnitage meie {terms} ja lugege meie {privacy}.",
        "killSSO": "Tühista kõik aktiivsed seansid",
        "msg": {
          "tokenExpired": "Paroolilingi või -koodi kehtivus on aegunud. Palun järgige linki, et oma parool lähtestada: {link}."
        },
        "privacy": "Andmekaitsetingimused",
        "terms": "Tingimused",
        "title": "Sisestage uus parool"
      }
    },
    "validations": {
      "hasDigit": "Peab sisaldama numbrit",
      "hasLowercase": "Peab sisaldama väikeseid tähti",
      "hasSpecial": "Peab sisaldama erimärke: {chars}",
      "hasUppercase": "Peab sisaldama suuri tähti",
      "invalidCharacters": "Sisaldab vigaseid märke",
      "maxLength": "Lubatud on maksimaalselt {max} märki",
      "minLength": "Vajalik on vähemalt {min} märki",
      "notSameAsEmail": "Liiga sarnane e-posti aadressiga",
      "onlyValidCharactersAllowed": "Lubatud on ainult tähed, numbrid ja tühikud.",
      "required": "Kohustuslik väli",
      "sameAsPassword": "Paroolid ei kattu",
      "tcAccepted": "Palun kinnitage meie kasutustingimused.",
      "validEmail": "Vigane e-posti aadress.",
      "validOTP": "Palun sisestage kinnituskood."
    }
  }
}
